import { apiFetch, apiFetchBlob } from "./api";

export interface MyobExportPreview {
  invoiceCount: number;
  paymentCount: number;
  totalDebits: number;
  totalCredits: number;
  cutoffAccountingDate: string | null;
  hasAnything: boolean;
}

export interface MyobExportRun {
  myobExportRunId: number;
  generatedAtUtc: string;
  generatedByName: string;
  cutoffAccountingDate: string | null;
  journalLineCount: number;
  invoiceCount: number;
  paymentCount: number;
  totalDebits: number;
  totalCredits: number;
  fileName: string | null;
  fileSizeBytes: number | null;
  status: string;
}

export interface MyobExportConfig {
  salesAccount: string;
  tradeDebtorsAccount: string;
  bankAccount: string;
  gstTaxCode: string;
  freeTaxCode: string;
  journalNumberPrefix: string;
}

export const myobExportApi = {
  preview: () => apiFetch<MyobExportPreview>("/api/reports/myob-export/preview"),
  generate: () => apiFetch<MyobExportRun>("/api/reports/myob-export/generate", { method: "POST" }),
  runs: (take = 50) => apiFetch<MyobExportRun[]>(`/api/reports/myob-export/runs?take=${take}`),
  getConfig: () => apiFetch<MyobExportConfig>("/api/reports/myob-export/config"),
  putConfig: (cfg: MyobExportConfig) =>
    apiFetch<void>("/api/reports/myob-export/config", { method: "PUT", body: JSON.stringify(cfg) }),
  download: async (runId: number, fileName: string) => {
    const blob = await apiFetchBlob(`/api/reports/myob-export/runs/${runId}/download`);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.rel = "noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Revoke after 60s — the browser needs the URL alive long enough to
    // process the click; immediate revocation can race in some browsers.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  },
};
